import { router } from "expo-router";
import { observer } from "mobx-react";
import React from "react";
import { ProgressBar } from "~/components/V2/ProgressBar";
import { View } from "~/components/V2/View";
import { useStandaloneBookingFlow } from "~/features/book-appointment/useStandaloneBookingFlow";
import { useStore } from "~/mobx/utils/useStore";
import { styleConstantsV2 as C } from "~/style/styleConstantsV2";
import { shadow } from "~/utils/shadow";
import { ButtonCircle } from "./ButtonCircle";
import { BodyText } from "./Text/BodyText";

interface StepTopNavProps {
  shouldAnimateProgressBar: boolean;
  onBackPress?: () => void;
  title: React.ReactNode;
}

export const StepTopNav = observer(function StepTopNav({
  shouldAnimateProgressBar,
  onBackPress,
  title,
}: StepTopNavProps) {
  const store = useStore();
  const shouldShowBackButton = router.canGoBack() || !!onBackPress;
  const showHeader = store.bookingStore.showHeader;

  const { isStandAloneBookingFlow } = useStandaloneBookingFlow();

  const shouldShowCloseButton = isStandAloneBookingFlow === false;

  return (
    <>
      <ProgressBar shouldAnimateProgressBar={shouldAnimateProgressBar} />
      <>
        {showHeader && (
          <View
            padding16
            flexDirectionRow
            alignItemsCenter
            colorWhite
            style={{
              ...shadow(4),
              zIndex: 10,
              // override web shadow
              boxShadow: `0px 1px 7px rgba(51, 51, 51, 0.1)`,
            }}
          >
            {shouldShowBackButton ? (
              <ButtonCircle
                iconName="left-arrow"
                size="small"
                backgroundColor={C.colorGrey10}
                onPress={() => {
                  if (onBackPress) {
                    onBackPress();
                  } else {
                    router.dismiss();
                  }
                }}
              />
            ) : (
              <View style={{ width: 20, height: 20 }} />
            )}
            <View flex centerContent>
              <BodyText weightBold sizeExtraLarge colorBlack>
                {title}
              </BodyText>
            </View>

            {shouldShowCloseButton && isStandAloneBookingFlow === false && (
              <ButtonCircle
                iconName="close"
                size="small"
                backgroundColor={C.colorGrey10}
                onPress={() => {
                  store.bookingStore.resetBooking();
                  router.dismissAll();
                  router.replace("/(app)");
                }}
              />
            )}
          </View>
        )}
      </>
    </>
  );
});
